import React, { useState, useEffect, useRef } from "react";
import "./about.css";
import { useNotification } from "../Notification/notification";
import Header, { Footer } from "../HomePage/header";

export default function About() {
  const { notify } = useNotification();
  const [isCompact, setIsCompact] = useState(false);
  const lastScrollY = useRef(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScrollY.current && currentScroll > 50) {
        setIsCompact(true);
      } else {
        setIsCompact(false);
      }

      lastScrollY.current = currentScroll;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <Header />
      <div className="about-container">
        {/* Hero Section */}
        <div className="about-hero">
          <h1>About Us</h1>
          <p>
            Your trusted platform for services, construction, and home
            solutions.
          </p>
        </div>

        {/* Company Info */}
        <div className="about-section">
          <h2>Who We Are</h2>
          <p>
            We are a service-based platform providing solutions for
            construction, plumbing, electrical work, and equipment installation.
            Our goal is to make it easy for customers to find reliable services
            in one place.
          </p>
        </div>

        {/* Mission & Vision */}
        <div className="about-section two-column">
          <div className="box">
            <h2>Our Mission</h2>
            <p>
              To deliver high-quality and affordable services while ensuring
              customer satisfaction and trust.
            </p>
          </div>

          <div className="box">
            <h2>Our Vision</h2>
            <p>
              To become the leading platform for home and construction services,
              connecting skilled professionals with customers seamlessly.
            </p>
          </div>
        </div>

        {/* Services */}
        <div className="about-section">
          <h2>What We Offer</h2>
          <ul>
            <li>Plumbing Services</li>
            <li>Electrical Installation & Repair</li>
            <li>Water Vessel Installation</li>
            <li>Construction Work</li>
            <li>Maintenance & Repair Services</li>
          </ul>
        </div>

        {/* Team */}
        <div className="about-section">
          <h2>Our Team</h2>
          <p>
            Our team consists of experienced professionals dedicated to
            delivering quality work and reliable service to our customers.
          </p>
        </div>

        {/* Contact CTA */}
        <div className="about-contact">
          <h2>Get in Touch</h2>
          <p>
            Have questions or need a service? Contact us today and we’ll help
            you get started.
          </p>
          <button
            onClick={() => {
              notify("Opening WhatsApp...", "info");
              window.open("https://wa.me/9779869838769", "_blank");
            }}
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Your existing footer */}
      <Footer />
    </>
  );
}
